import React from 'react';
import classes from './Stepper.module.css';

type StepType = {
  displayText: string;
};

type Props = {
  steps: StepType[];
  activeStep: number;
  setActiveStep?: (val: number) => void;
};

const Stepper: React.FC<Props> = ({ steps, activeStep, setActiveStep }) => {
  return (
    <div className={classes.stepper}>
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <div
            className={`${classes.stepGroup} ${activeStep < index ? classes.inactiveStep : ''}`}
            onClick={() => {
              setActiveStep && setActiveStep(index);
            }}
          >
            <div className={classes.stepNumber}>{index + 1}</div>
            <div className={classes.stepDescription}>{step.displayText}</div>
          </div>
          {index < steps.length - 1 && <div className={classes.stepDivider} />}
        </React.Fragment>
      ))}
    </div>
  );
};

export { Stepper };
